import { Injectable } from '@angular/core';
import { DataCollectorService } from '../../../core/services/data_collector_services/data_collector_service.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { DispatchFilterModule, DispatchTab } from '../../../../../projects/dispatch-board/src/app/components/dispatch-board/dispatch-board.interface';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdvanceFilterService {
  filterObj: any = {};
  get filterApi(): any{
    return `${this.dataCollectorService.baseurl()}/misc/quick_filters`;
  };
  isFormOpen$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  dispatchBoardFilterValues = { jobs: { grid: [], scheduler: [], employee: [], map: [] },
  // eslint-disable-next-line @typescript-eslint/naming-convention
  routes: { grid: [], grid_route: [], scheduler: [], scheduler_route: [], employee: [], map: [] } };
  constructor(private dataCollectorService: DataCollectorService,
              private utilityService: UtilityService){
  }

  getFilterUpdateUrl(filterId: any): string{
    return `${this.dataCollectorService.baseurl()}/misc/quick_filters/${filterId}`;
  }

  getValidFilters(filters: any): any{
    return filters?.filter((data: any)=> !this.utilityService.isEmptyOrUndefined(data?.key) &&
                            !this.utilityService.isEmptyOrUndefined(data?.operator) &&(
                            ['IS_EMPTY','IS_NOT_EMPTY'].includes(data?.operator) ||
                            data?.value === true || data?.value === false || data?.value?.length > 0 || !this.utilityService.isEmptyOrUndefined(data?.value)));
  }

  updateDispatchFilterValue(selectedDispatchTab: DispatchTab, module: DispatchFilterModule, filterValue: any): void {
    this.dispatchBoardFilterValues[selectedDispatchTab][module] = filterValue;
  }
}
